// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { cilInfo, cilXCircle } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import {
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CListGroup,
  CListGroupItem,
  CPopover,
  useDebouncedCallback,
} from "@coreui/react-pro";
import { useEffect, useRef, useState } from "react";
import useMapbox from "../../../../hooks/use-mapbox";
import { shornSeg } from "../../../../tools/set-seg-tag";

const Locale = ({ segment, search, segmentSearch, onChange, ...props }) => {
  const [filteredSegs, setFilteredSegs] = useState([]);
  const [types, setTypes] = useState([]);
  const [value, setValue] = useState("");
  const [defaultValue, setDefaultValue] = useState("");
  const [filter, setFilter] = useState("");
  const [error, setError] = useState("");
  const [errorClass, setErrorClass] = useState("");
  const initialised = useRef(false);
  const touched = useRef(false);

  const { search: mapSearch, rawResults: results } = useMapbox({
    types,
    country: props.country ?? ["gb"],
  });

  useEffect(() => {
    if (segment && segment.options) {
      setTypes(segment.options);
    }
  }, [segment]);

  useEffect(() => {
    if (!initialised.current && types.length > 0) {
      const parts = Array.from(
        new Set(
          Object.keys(search)
            .filter((k) => [...types, "geo_point"].includes(shornSeg(k)))
            .flatMap((k) => search[k]),
        ),
      );

      if (parts && parts.length > 0) {
        if (parts[0].includes(";")) {
          const [n] = parts[0].split(";");
          setValue(n);
        } else {
          setValue(parts[0]);
        }
      }

      setTimeout(() => (initialised.current = true), 100);
    }
  }, [search, types]);

  useEffect(() => {
    if (initialised.current) {
      mapSearch(value);
    }
  }, [value]);

  const selectValue = ({ name, coordinates }, type) => {
    touched.current = false;
    initialised.current = false;
    mapSearch(undefined);
    setValue(name);
    setTimeout(() => {
      initialised.current = true;
    }, 100);

    let acts = [...types, "geo_point"]
      .filter((t) => t !== type)
      .map((t) => ({
        replace: true,
        name: `${t}:or`,
        value: "",
      }));

    let newAct = {};

    if (type === "postcode") {
      newAct = [
        {
          name: `${type}:or`,
          value: name,
          replace: true,
        },
      ];
    } else {
      if (coordinates) {
        const val = `${name};${coordinates.latitude};${coordinates.longitude}`;
        newAct = [
          {
            name: `place:or`,
            value: "",
            replace: true,
          },
          {
            name: `geo_point:or`,
            value: val,
            replace: true,
          },
        ];
      } else {
        newAct = [
          {
            name: `${type}:or`,
            value: name,
            replace: true,
          },
        ];
      }
    }
    acts = [...acts, ...newAct];

    onChange(acts);
  };

  const touch = useDebouncedCallback(() => (touched.current = true), 500);

  return (
    <>
      <div className={"search-segment-container d-flex"}>
        <div style={{ width: "15rem", position: "relative" }}>
          <CInputGroup size={"sm"}>
            {segment?.help && (
              <CInputGroupText>
                <CPopover content={segment.help} trigger={["hover", "focus"]}>
                  <span>
                    <CIcon icon={cilInfo} size={"sm"} style={{ cursor: "help" }} />
                  </span>
                </CPopover>
              </CInputGroupText>
            )}
            <CFormInput
              style={{ paddingRight: segment?.allowClear && !error && !!value ? "1.7rem" : 0 }}
              className={error && "is-invalid"}
              size={"sm"}
              placeholder={segment.title}
              data-testid="locale-input"
              feedbackInvalid={error}
              value={value}
              onChange={(e) => {
                touch();
                setValue(e.target.value);
              }}
              onKeyUp={(k) => {
                if (k.code === "Enter") {
                  if (results.length > 0) {
                    const {
                      properties: { name_preferred, feature_type, coordinates },
                    } = results[0];
                    selectValue({ name: name_preferred, coordinates }, feature_type);
                  } else {
                    selectValue({ name: value }, "place");
                  }
                  touched.current = false;
                }
              }}
            />
            {segment?.allowClear && !error && !!value > 0 && (
              <span
                className={"position-absolute top-50 end-0 translate-middle search-control__clear"}
                color={"secondary"}
                variant={"outline"}
                onClick={() => selectValue({ name: "" }, "place")}
              >
                <CIcon icon={cilXCircle} />
              </span>
            )}
          </CInputGroup>
          <CListGroup className={"search-control__locale-list"}>
            <>
              {results.map(
                ({
                  id,
                  properties: { name_preferred, feature_type, place_formatted, coordinates },
                }) => (
                  <CListGroupItem
                    key={id}
                    data-testid="locale-option"
                    data-feature-type={feature_type}
                    onClick={() => {
                      selectValue({ name: name_preferred, coordinates }, feature_type);
                    }}
                  >
                    <div>{name_preferred}</div>
                    <span className={"text-muted"} style={{ fontSize: "0.8rem" }}>
                      {place_formatted}
                    </span>
                  </CListGroupItem>
                ),
              )}
            </>
          </CListGroup>
        </div>
      </div>
    </>
  );
};

export default Locale;
